import React from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'react-router/lib/Link';
import suitcss from '../../../helpers/suitcss';
import { capitalize } from '../../../helpers/str';

import Copy from '../../basics/text/TextCopy';
import Link from '../../basics/text/TextLink';
import MediaImageBackground from '../../basics/media/MediaImageBackground';

import imageSizes from '../../../config/imageSizes';
import { imageShape } from '../../../propTypes/media';

function HeaderItemInfo(props) {
  const { copy, image, link, align, position, featured } = props;
  const backgroundImage = {
    ...image,
    sizes: imageSizes[featured ? 'headerItemBackgroundFeatured' : 'headerItemBackground'],
  };
  return (
    <MediaImageBackground
      className={suitcss({
        componentName: 'HeaderStageItem',
        modifiers: [
          'typeInfo',
          align && `align${capitalize(align)}`,
          position && `position${capitalize(position)}`,
          featured && 'featured',
        ],
      })}
      {...backgroundImage}
      isLazy
    >
      {!featured && link &&
        <RouterLink
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'ctaOverlay',
          })}
          to={link.url}
          target={link.target}
        />
      }
      {copy &&
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'inner',
          })}
        >
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'content',
            })}
          >
            <div
              className={suitcss({
                componentName: 'HeaderStageItem',
                descendantName: 'copy',
              })}
            >
              <Copy raw embedded inverted>{copy}</Copy>
            </div>
            {featured && link &&
              <div
                className={suitcss({
                  componentName: 'HeaderStageItem',
                  descendantName: 'link',
                })}
              >
                <Link
                  to={link.url}
                  asButton
                  buttonFilled
                  target={link.target}
                >
                  {link.title}
                </Link>
              </div>
            }
          </div>
        </div>
      }
    </MediaImageBackground>
  );
}

HeaderItemInfo.propTypes = {
  copy: PropTypes.string,
  link: PropTypes.object,
  image: imageShape,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  position: PropTypes.oneOf(['top', 'center', 'bottom']),
  featured: PropTypes.bool,
};

HeaderItemInfo.defaultProps = {};

export default HeaderItemInfo;
